import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon34: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        d="M16.079 0c1.034 0 1.974.4 2.675 1.054a.48.48 0 0 1 .152.151A3.905 3.905 0 0 1 20 3.921v6.188A3.89 3.89 0 0 1 16.109 14H3.891A3.89 3.89 0 0 1 0 10.109V3.921A3.922 3.922 0 0 1 3.921 0h12.158ZM12.52 7.642l-1.192 1.099a1.997 1.997 0 0 1-2.661-.006L7.48 7.642l-5.484 4.651a2.88 2.88 0 0 0 1.725.702l.17.005h12.218c.725 0 1.388-.267 1.896-.708l-5.485-4.65ZM1.565 2.194A2.908 2.908 0 0 0 1 3.921v6.188c0 .51.132.99.364 1.406l5.375-4.556-5.174-4.765Zm16.872.004L13.262 6.96l5.374 4.554c.206-.369.333-.789.359-1.235l.005-.17V3.921c0-.644-.209-1.24-.563-1.723ZM16.079 1H3.921c-.605 0-1.168.184-1.635.5l7.053 6.494A.993.993 0 0 0 10.656 8l7.061-6.498A2.91 2.91 0 0 0 16.079 1Z"
      />
    </Svg>
  )
}
